import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './newarrivalweb.css';

export default class NewArrivalWeb extends Component {
    render() {
        return (
            <>
            <div className="new-arrivall-com-webversion-main-sectionx">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="new-arrivallx-wexv-dot-main-sec-bboxx-web-version">
                                <div className="new-arrivval-dott-ccm-dealmmnnff-bb-web-verrsn">
                                    <p><span><img src={require('../../../assets/new-arrival-icon.svg')} alt="orponbd online shop"/></span> New Arrival</p>
                                    <Link to="/new-arrival-all-products"><span>View More <i className="fa fa-angle-right"></i></span></Link>
                                </div>

                                <div className="row new-arrivval-com-delproj-rww-webb-versnn">
                                    <div className="col-md-2 col-6">
                                        <div className="new-arrivvall-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="new-arrivl-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-7.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="new-arrivl-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="new-arrivvall-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="new-arrivl-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-8.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="new-arrivl-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="new-arrivvall-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="new-arrivl-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-9.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="new-arrivl-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="new-arrivvall-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="new-arrivl-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-10.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="new-arrivl-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="new-arrivvall-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="new-arrivl-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-11.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="new-arrivl-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="new-arrivvall-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="new-arrivl-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-12.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="new-arrivl-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}
